angular.module('clientDashboardApp').directive('includeReplace', function () {
  return {
    require: 'ngInclude',
    restrict: 'A',
    compile: function (tElement, tAttrs) {
      tElement.replaceWith(tElement.children());
      return {
        post : angular.noop
      };
    }
  };
});
